import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IMallState } from "../models/Mall";

const initialState: IMallState = {
  name: null,
  id: null,
};

const mallSlice = createSlice({
  name: "mall",
  initialState,
  reducers: {
    setName(state, action: PayloadAction<string>) {
      state.name = action.payload;
    },

    setId(state, action: PayloadAction<number>) {
      state.id = action.payload;
    },
  },
});

export const { setName, setId } = mallSlice.actions;

export default mallSlice.reducer;
